import script from "./AskCheckOrSetupLevel.vue?vue&type=script&setup=true&lang=js"
export * from "./AskCheckOrSetupLevel.vue?vue&type=script&setup=true&lang=js"

import "./AskCheckOrSetupLevel.vue?vue&type=style&index=0&id=6861be9a&lang=css"
import "./AskCheckOrSetupLevel.vue?vue&type=style&index=1&id=6861be9a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6861be9a"]])

export default __exports__